<section class="w-11/12 mx-auto py-24">

  <div class="grid md:grid-cols-2 gap-16 items-center">

    <div>

      <h2 class="text-4xl font-light mb-6">
        A Modern Model for Enterprise Delivery
      </h2>

      <p class="text-lg text-gray-700 mb-6">
        Enterprises today operate increasingly complex technology landscapes.
        Fragmented delivery teams, rising vendor costs, and slow innovation
        cycles create barriers to digital transformation.
      </p>

      <p class="text-lg text-gray-700">
        The CIC Global Capability Center centralizes engineering talent,
        governance, and platform expertise into a scalable operating model
        designed to accelerate enterprise transformation.
      </p>

    </div>


    <div class="grid grid-cols-2 gap-6 text-center">

      <div class="bg-primary-100 p-8 rounded-xl border border-primary-200">
        <p class="text-4xl font-light text-primary-800">30%</p>
        <p class="text-gray-700 mt-2">Faster Delivery</p>
      </div>

      <div class="bg-primary-100 p-8 rounded-xl border border-primary-200">
        <p class="text-4xl font-light text-primary-800">40%</p>
        <p class="text-gray-700 mt-2">Lower Vendor Cost</p>
      </div>

      <div class="bg-primary-100 p-8 rounded-xl border border-primary-200">
        <p class="text-4xl font-light text-primary-800">24/7</p>
        <p class="text-gray-700 mt-2">Operations</p>
      </div>

      <div class="bg-primary-100 p-8 rounded-xl border border-primary-200">
        <p class="text-4xl font-light text-primary-800">1</p>
        <p class="text-gray-700 mt-2">Unified Team</p>
      </div>

    </div>

  </div>

</section>